export const authProviderNames: Record<string, string> = {
  "google.com": "google",
  "microsoft.com": "microsoft",
  password: "email",
};

export function getProviderSource(firebaseData: any): string {
  const providerId =
    firebaseData?._tokenResponse?.providerId ??
    firebaseData?.user?.providerData?.[0]?.providerId ??
    "password";
  return authProviderNames[providerId] ?? "email";
}
